import { render, staticRenderFns } from "./goods_receipt.vue?vue&type=template&id=589d10c2&scoped=true"
import script from "./goods_receipt.vue?vue&type=script&lang=js"
export * from "./goods_receipt.vue?vue&type=script&lang=js"
import style0 from "./goods_receipt.vue?vue&type=style&index=0&id=589d10c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d10c2",
  null
  
)

export default component.exports